export const Edit = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Rediger</title>
      <g clipPath="url(#clip0_7236_214)">
        <path
          d="M5.99967 13.3333L1.33301 14.6667L2.66634 10L10.9423 1.724C11.463 1.20333 12.307 1.20333 12.8277 1.724L14.2757 3.172C14.7963 3.69266 14.7963 4.53666 14.2757 5.05733L5.99967 13.3333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33301 3.3335L12.6663 6.66683"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7236_214">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
